export default __webpack_public_path__ + "static/media/about-main-lg.579700d0.jpg";